module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"source-filter":"Source Filter","status-filter":"Status Filter","start-date":"Start Placed At Date","end-date":"End Placed At Date","outstanding-and-processing":"Outstanding and processing","assigned-to-me":"Assigned To Me"}}')
  delete Component.options._Ctor
}
